import type { IntegrationFieldValue } from './IntegrationFieldReview'

export const hasFieldValue = (integrationFieldValue: IntegrationFieldValue | undefined | null) =>
  integrationFieldValue !== undefined && integrationFieldValue !== null && integrationFieldValue !== ''
